import Swiper from 'swiper';
import { Manipulation, Navigation, Pagination } from 'swiper/modules';
// These CSS imports are handled in the main.scss file
//import 'swiper/css';
//import 'swiper/css/navigation';
//import 'swiper/css/pagination';
//import 'swiper/css/manipulation';

export default function initSwiper() {

  const initSwiper = new Swiper('#program-carousel .swiper', {

    modules: [Navigation, Pagination],

    // Optional parameters
    speed: 750,
    loop: true,
    centeredSlides: true,
    centeredSlidesBounds: true,

    // If we need pagination
    pagination: {
      el: '#program-carousel .swiper-pagination',
    },

    // Navigation arrows
    navigation: {
      nextEl: '#program-carousel .btn-arrow-right',
      prevEl: '#program-carousel .btn-arrow-left',
    },

    // And if we need scrollbar
    scrollbar: {
      el: '#program-carousel .swiper-scrollbar',
    },

  });

  // Carousel - Large Card
  const swiperCarouselsLarge = document.querySelectorAll('.carousel-lg-card .swiper');

  swiperCarouselsLarge.forEach(carousel => {
    const initialSlides = carousel.querySelectorAll('.swiper-slide');
    const pagination = carousel.querySelector('.swiper-pagination');
    const nextButton = carousel.querySelector('.btn-arrow-right');
    const prevButton = carousel.querySelector('.btn-arrow-left');

    const slider = new Swiper(carousel, {

      modules: [Navigation, Manipulation],

      speed: 750,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 24,
      initialSlide: 0,
      loopAdditionalSlides: 2,

      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1200: {
          slidesPerView: 2,
          spaceBetween: 48,
        },
      },

      pagination: {
        el: pagination,
      },

      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },

      on: {
        init: function (swiper) {
          if (swiper.slides.length > 2) {
            for (let i = initialSlides.length - 1; i > -1; i--) {
              const newSlide = initialSlides[i].cloneNode(true);

              swiper.prependSlide(newSlide);
            }

            swiper.update();
          }
        },
      },
    });
  });

  // Photo Showcase
  const swiperPhotoShowcase = document.querySelectorAll('.photo-showcase-gallery .swiper');

  swiperPhotoShowcase.forEach(carousel => {
    const pagination = carousel.querySelector('.swiper-pagination');
    const nextButton = carousel.querySelector('.btn-arrow-right');
    const prevButton = carousel.querySelector('.btn-arrow-left');

    const slider = new Swiper(carousel, {

      modules: [Navigation, Pagination],

      speed: 750,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 24,

      pagination: {
        el: pagination,
      },

      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
    });
  });

  // Featured Carousels
  const swiperCarouselsFeatured = document.querySelectorAll('.featured-carousel .swiper');

  swiperCarouselsFeatured.forEach(carousel => {
    const pagination = carousel.querySelector('.swiper-pagination');
    const nextButton = carousel.querySelector('.btn-arrow-right');
    const prevButton = carousel.querySelector('.btn-arrow-left');

    const slider = new Swiper(carousel, {

      modules: [Navigation, Pagination],

      speed: 750,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 24,

      pagination: {
        el: pagination,
      },

      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },

    });
  });

  // Program Showcase
  const swiperProgramShowcase = document.querySelectorAll('.program-showcase .swiper');

  swiperProgramShowcase.forEach(carousel => {
    const pagination = carousel.querySelector('.swiper-pagination');
    const nextButton = carousel.querySelector('.swiper-button-next');
    const prevButton = carousel.querySelector('.swiper-button-prev');

    const slider = new Swiper(carousel, {

      modules: [Navigation, Pagination],

      speed: 750,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 24,

      pagination: {
        el: pagination,
        type: 'bullets',
        clickable: true,
      },

      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },

      cssMode: false,

      allowTouchMove: true,

    });
  });

  // Testimonials
  const swiperTestimonials = document.querySelectorAll('.testimonials .swiper');

  swiperTestimonials.forEach(carousel => {
    const pagination = carousel.querySelector('.swiper-pagination');
    const nextButton = carousel.querySelector('.btn-arrow-right');
    const prevButton = carousel.querySelector('.btn-arrow-left');

    new Swiper(carousel, {
      modules: [Navigation, Pagination],
      speed: 500,
      slidesPerView: 1,
      spaceBetween: 20,
      watchOverflow: true,
      grabCursor: true,
      loop: true,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      },
      pagination: {
        el: pagination,
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
    });
  });

}
